(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-cart-discounts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('bc:cart-rendered',function(event){
  var cart=event.detail;if(!cart)return;
  var discounts=cart.cart_level_discount_applications||[];
  document.querySelectorAll('[data-bc-discount-shipping]').forEach(function(note){note.hidden=!discounts.length;});
  document.querySelectorAll('[data-bc-cart-discounts]').forEach(function(container){
    container.replaceChildren();container.hidden=!discounts.length;
    discounts.forEach(function(discount){
      var row=document.createElement('div');row.className='bc-cart-discounts__row';
      var name=document.createElement('span');name.textContent=discount.title;
      var value=document.createElement('span');
      var currency=cart.currency||'USD';
      value.textContent='−'+new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency,currencyDisplay:currency==='USD'?'symbol':'code'}).format(discount.total_allocated_amount/100);
      row.append(name,value);container.append(row);
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cro-pdp-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('[data-cro-mobile-atc]').forEach((bar) => {
    const originalButton = document.querySelector('[data-atc-button]');
    const stickyButton = bar.querySelector('[data-cro-mobile-button]');
    const stickyPrice = bar.querySelector('[data-cro-mobile-price]');
    const stickySize = bar.querySelector('[data-cro-mobile-size]');
    const form = document.querySelector('[data-product-form]');

    if (!originalButton || !stickyButton || !form) return;

    const sizeInputs = [...form.querySelectorAll('input[data-option-name="Size"]')];
    if (stickySize) {
      sizeInputs.forEach(input => {
        const option = document.createElement('option');
        option.value = input.value;
        const label = document.querySelector('label[for="' + input.id + '"]');
        option.textContent = label ? label.textContent.trim() : input.value;
        option.disabled = input.disabled;
        stickySize.append(option);
      });
      stickySize.hidden = !sizeInputs.length;
      stickySize.addEventListener('change', () => {
        const input = sizeInputs.find(input => input.value === stickySize.value);
        if (input && !input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', {bubbles:true}));
          stickySize.blur();
        }
      });
    }
    const sync = () => {
      const currentPrice = document.querySelector('[data-product-price] .product-info__price--current');
      if (currentPrice && stickyPrice) stickyPrice.textContent = currentPrice.textContent.trim();
      const selectedSize = form.querySelector('input[data-option-name="Size"]:checked');
      if (stickySize && selectedSize) stickySize.value = selectedSize.value;
      stickyButton.disabled = originalButton.disabled;
      const originalText = originalButton.querySelector('[data-atc-text]');
      if (originalText) stickyButton.textContent = originalText.textContent.trim();
    };

    stickyButton.addEventListener('click', () => {
      if (!stickyButton.disabled) originalButton.click();
    });

    form.addEventListener('change', sync);

    const mutationObserver = new MutationObserver(sync);
    mutationObserver.observe(originalButton, { attributes: true, childList: true, subtree: true });
    const priceContainer = document.querySelector('[data-product-price]');
    if (priceContainer) mutationObserver.observe(priceContainer, { childList: true, subtree: true });

    if (bar.parentElement !== document.body) document.body.append(bar);
    // Read viewport position without moving focus or scrolling the document.
    let scheduled = false;
    const updateVisibility = () => {
      scheduled = false;
      const blocked = document.body.style.overflow === 'hidden';
      const visible = originalButton.getBoundingClientRect().bottom < 0 && !blocked;
      if (bar.hidden !== !visible) bar.hidden = !visible;
      if (bar.classList.contains('is-visible') !== visible) bar.classList.toggle('is-visible', visible);
    };
    const schedule = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(updateVisibility); }
    };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    new MutationObserver(schedule).observe(document.body, {attributes:true, attributeFilter:['style','class']});
    updateVisibility();
    sync();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
